/**
 * Portfolio documents are user-authored source data. These limits keep the
 * contract safe to validate in both a browser and a Worker. The standard farm
 * can project this complete holding envelope; specialized callers may still
 * request a smaller scene explicitly.
 */
export const PORTFOLIO_SCHEMA_VERSION = 1 as const;
/**
 * Envelope v4 marks records that may carry a durable `baseHatId`.
 * Envelope v3 introduced durable `basePaletteId`.
 * Envelope v2 introduced cost-basis currency metadata.
 * The portfolio document itself remains v1; old readers fail safely on the
 * outer future version instead of misclassifying the new nested field.
 */
export const LOCAL_PORTFOLIO_STORAGE_SCHEMA_VERSION = 4 as const;

/** Product limit for newly created or expanded portfolios. */
export const MAX_PORTFOLIO_HOLDINGS = 50;
/**
 * Read compatibility for records written before the product limit became 50.
 * New commands must use MAX_PORTFOLIO_HOLDINGS instead.
 */
export const MAX_STORED_PORTFOLIO_HOLDINGS = 100;
export const MAX_PURCHASE_LOTS_PER_HOLDING = 500;
export const MAX_PURCHASE_LOTS_PER_PORTFOLIO = 10_000;
export const MAX_MANUAL_QUOTES = MAX_STORED_PORTFOLIO_HOLDINGS;

export const MAX_DECIMAL_DIGITS = 30;
export const MAX_DECIMAL_SCALE = 12;
/** Renderer DTOs intentionally stay well below Number.MAX_SAFE_INTEGER. */
export const MAX_RENDERER_DECIMAL_ABS = 1_000_000_000_000_000;

export const MAX_IDENTIFIER_LENGTH = 128;
export const MAX_TICKER_LENGTH = 20;
export const MAX_INSTRUMENT_NAME_LENGTH = 120;
export const MAX_VENUE_LENGTH = 32;
export const MAX_MEMO_LENGTH = 2_000;
export const MAX_NICKNAME_LENGTH = 40;
export const MAX_ASSET_REFERENCE_LENGTH = 96;

export const ASSET_KINDS = ["stock", "etf", "cash", "unknown"] as const;
export const QUOTE_STATUSES = ["valid", "stale", "missing", "new"] as const;
export const QUOTE_SOURCES = ["manual", "yahoo-finance"] as const;

export const SLIME_PALETTE_IDS = [
  "leaf",
  "lime",
  "lemon",
  "sky",
  "aqua",
  "cobalt",
  "denim",
  "coral",
  "cherry",
  "rose",
  "honey",
  "mango",
  "tangerine",
  "violet",
  "indigo",
  "grape",
  "orchid",
  "mint",
  "teal",
  "lagoon",
  "berry",
  "apricot",
  "forest",
  "moss",
  "cocoa",
] as const;

export const SLIME_PATTERN_IDS = ["plain", "speckle", "stripe"] as const;
